export default class SortableView extends Backbone.View
  events:
    "nested:fieldAdded"    : "updatePositionValues"
    "nested:fieldRemoved"  : "updatePositionValues"
    "sortstop"             : "onSortStop"
    "sortchange"           : "onSortChange"

  initialize: (options) ->
    @$fieldValues = @$el.find(".js-sortable")
    @$fieldValues.sortable
      items: ".fields"
      handle: ".sort-handle"
      axis: "y"

    @updatePositionValues()

  updatePositionValues: ->
    @$fieldValues.find(".js-item-with-position:visible").each (index) ->
      $row = $(this)
      $row.find("input.js-position").val(index)
      $row.find(".position").text(index + 1)

    @$fieldValues.sortable("refresh")

  onSortChange: (e, ui) ->
    $(".sortable-item").removeClass("last")

    if ui.item.is(":last-of-type")
      ui.item.prevAll(".sortable-item:first").addClass("last")

  onSortStop: ->
    $(".sortable-item").removeClass("last")
    @updatePositionValues()



// WEBPACK FOOTER //
// ./app/javascript/backbone/shared/views/sortable_view.js.coffee